/* eslint-disable react/jsx-one-expression-per-line */
import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    displayDiv: {
      padding: theme.spacing(1),
    },
    from: {
      paddingRight: "0.15rem",
    },
    to: {
      paddingRight: theme.spacing(1),
      paddingLeft: "0.15rem",
    },
    total: {
      paddingLeft: theme.spacing(1),
    },
    message: {
      paddingLeft: theme.spacing(1),
      fontSize: "0.7rem",
    },
  })
);

interface Props {
  fromNumber?: number;
  toNumber?: number;
  totalNumber?: number;
  message?: string;
}

/** ページャー */
export function PageDisplay(props: Props) {
  const classes = useStyles();

  const { fromNumber } = props;
  const { toNumber } = props;
  const { totalNumber } = props;
  const { message } = props;

  let displayDiv = <div />;
  if (fromNumber && toNumber && totalNumber) {
    displayDiv = (
      <div className={classes.displayDiv}>
        <span className={classes.from}>{fromNumber}</span>-
        <span className={classes.to}>{toNumber}</span>/
        <span className={classes.total}>{totalNumber}</span>
        <span className={classes.message}>{message}</span>
      </div>
    );
  }
  return displayDiv;
}
